import { render, staticRenderFns } from "./ConclusionM.vue?vue&type=template&id=50b5d9e4"
import script from "./ConclusionM.vue?vue&type=script&lang=js"
export * from "./ConclusionM.vue?vue&type=script&lang=js"
import style0 from "./ConclusionM.vue?vue&type=style&index=0&id=50b5d9e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports